import React from 'react'
import IconButton from '@mui/material/IconButton'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import PinterestIcon from '@mui/icons-material/Pinterest'

import { T } from '../../utils/Typography'

const Footer = React.memo(() => {
  const navInstagram = () =>
    window.open('https://instagram.com/might_could', '_blank')
  const navFacebook = () =>
    window.open('https://www.facebook.com/mightcouldstudios', '_blank')
  const navTwitter = () =>
    window.open('https://twitter.com/might_could', '_blank')
  const navPinterest = () =>
    window.open('https://www.pinterest.com/mightcouldillo/', '_blank')
  return (
    <div
      className='App-footer'
      style={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 75,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        paddingLeft: 25,
        paddingRight: 25,
        boxSizing: 'border-box',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginRight: 10,
          marginLeft: 10,
        }}>
        <T
          style={{
            margin: 0,
            whiteSpace: 'nowrap',
            color: 'white',
            fontFamily: 'Lora',
            fontSize: 13,
            lineHeight: '44px',
          }}>
          © 2021 Roils LLC, All rights reserved
        </T>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'space-evenly',
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-evenly',
            lineHeight: '44px',
            marginLeft: 10,
            marginRight: 10,
          }}>
          <T
            style={{
              whiteSpace: 'nowrap',
              margin: 0,
              color: 'white',
              fontFamily: 'Lora',
              fontSize: 13,
              marginRight: 10,
            }}>
            <a
              href='https://www.pineapplepodcasting.com/terms'
              style={{ color: 'white' }}>
              Terms and Conditions
            </a>
          </T>
          <T
            style={{
              whiteSpace: 'nowrap',
              margin: 0,
              color: 'white',
              fontFamily: 'Lora',
              fontSize: 13,
            }}>
            <a
              href='https://www.pineapplepodcasting.com/Privacy'
              style={{ color: 'white' }}>
              Privacy Policy
            </a>
          </T>
          {/* <div style={{ flexShrink:1, width:30, height:10, backgroundColor:'red' }}/> */}
        </div>
        <div style={{}}>
          <IconButton onClick={navInstagram} aria-label='instagram'>
            <InstagramIcon fontSize='small' style={{ color: 'white' }} />
          </IconButton>
          {/* <IconButton aria-label="medium"><FacebookIcon style={{color:'white'}} /></IconButton> */}
          <IconButton onClick={navFacebook} aria-label='facebook'>
            <FacebookIcon fontSize='small' style={{ color: 'white' }} />
          </IconButton>
          <IconButton onClick={navTwitter} aria-label='twitter'>
            <TwitterIcon fontSize='small' style={{ color: 'white' }} />
          </IconButton>
          <IconButton onClick={navPinterest} aria-label='pinterest'>
            <PinterestIcon fontSize='small' style={{ color: 'white' }} />
          </IconButton>
        </div>
      </div>
      {/* <img src={logo} className="App-logo" alt="logo" /> */}
    </div>
  )
})
export default Footer
